import "./ModalInput.css";
import React, { useState } from "react";
import reactDom from "react-dom";
import { ReactDOM } from "react-dom";
import { useContext } from "react";
import { createContext } from "react";
import {ModalCongrats} from './ModalCongrats'
import { bookmarkContext } from "./App";


export const ModalContext = createContext();
export function ModalProvider({ children }){
  const [modal, setModal] = useState(false);
  var [congrats, Show] = useState(false)
  return (
    <ModalContext.Provider value={{ modal, setModal, congrats, Show }}>
      {children}
    </ModalContext.Provider>
  ); 
  
};

var no_reward_style = {
  height: 150,
  width: 650,
  borderRadius: 15,
  border: "1px solid hsl(0, 0%, 85%)",
};

var modal_styles = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  lineHeight: 1.4,
  background: "#f8f8f8",
  padding: "14px 28px",
  borderRadius: 15,
  maxWidth: 700,
  minWidth: 700,
  minHeight: 880,
  maxHeight: 900,
  fontFamily: "Commissioner, sans-serif",
};

var bamboo_styles = {
  border: "1px solid hsl(0, 0%, 85%)",
  height: 160,
  width: 650,
  borderRadius: 15,
};

var black_styles = {
  border: "1px solid hsl(0, 0%, 85%)",
  height: 160,
  width: 650,
  borderRadius: 15,
};
export function Modal_input() {
  var [bambooPledge, SetbambooPledge] = useState(false);
  var [pledge, ShowPledge] = useState(false);
  var [blackPledge, SetBlackPledge] = useState(false);
  var [close, Setclose] = useState(false);
  const { modal, setModal }= useContext(ModalContext)
  var {congrats, Show} = useContext(ModalContext)
  var {backers, Setbackers} = useContext(bookmarkContext)
  var [donation , setDonation] = useState(0)
  var {backed, Setbacked} = useContext(bookmarkContext)
  const ExpandBlack = () => {
    black_styles = {
      border: "2px solid hsl(176, 50%, 47%)",
      height: 250,
      width: 650,
      borderRadius: 15,
    };
  };
  const ReverseBlack = () => {
    black_styles = {
      border: "1px solid hsl(0, 0%, 85%)",
      height: 160,
      width: 650,
      borderRadius: 15,
    };
  };
  const ReverseModal = () => {
    modal_styles = {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      lineHeight: 1.4,
      background: "#f8f8f8",
      padding: "14px 28px",
      borderRadius: 15,
      maxWidth: 700,
      minWidth: 700,
      minHeight: 880,
      maxHeight: 900,
      fontFamily: "Commissioner, sans-serif",
    };
  };
  const Expandbamboo = () => {
    bamboo_styles = {
      border: "2px solid hsl(176, 50%, 47%)",
      height: 250,
      width: 650,
      borderRadius: 15,
    };
  };
  const Reversebamboo = () => {
    bamboo_styles = {
      border: "1px solid hsl(0, 0%, 85%)",
      height: 160,
      width: 650,
      borderRadius: 15,
    };
  };
  const ExpandModal = () => {
    modal_styles = {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      lineHeight: 1.4,
      background: "#f8f8f8",
      padding: "14px 28px",
      borderRadius: 15,
      maxWidth: 700,
      minWidth: 700,
      minHeight: 970,
      maxHeight: 900,
      fontFamily: "Commissioner, sans-serif",
    };
  };
  const ReversePledge = () => {
    no_reward_style = {
      height: 150,
      width: 650,
      borderRadius: 15,
      border: "1px solid hsl(0, 0%, 85%)",
    };
  };

  const AddingPledge = () => {
    no_reward_style = {
      height: 250,
      width: 650,
      borderRadius: 15,
      border: "2px solid hsl(176, 50%, 47%)",
    };
  };
  const CongratsModal = () => {
    Show(!congrats)
    Setbackers(backers + 1)
    Setbacked(backed + donation)
  }
  return (
    <>            
      {congrats === true ? ModalCongrats() : null}
      {modal === true ? (
      <div className="modal">
        <div className="overlay">
          <div className="modal-content" style={modal_styles}>
            <button className="close-modal" onClick={() => setModal(!modal)}>
              <img src="icon-close-modal.svg" alt="x_button" />
            </button>
            <div className="Modal_title">Back this project</div>
            <div className="modal_desc">
              Want to support us in bringing Mastercraft Bamboo Monitor Riser
              out in the world?
            </div>
            <div className="pledge_container" id="pledge_container">
              <div className="no_reward" style={no_reward_style}>
                <label htmlFor="choose_pledge" className="radio">
                  <input
                    type="radio"
                    name="no_reward"
                    id="choose_pledge"
                    className="radio__input"
                    onChange={() => SetbambooPledge((bambooPledge = false))}
                    onClick={() => SetBlackPledge((blackPledge = false))}
                    onClick={() => ShowPledge((pledge = true))}
                  />
                  <div className="radio__radio"></div>
                  <div className="no_reward_title">
                    <span
                      style={{
                        position: "relative",
                        left: 32,
                        top: 21,
                        fontWeight: 700,
                        fontSize: 19,
                      }}
                    >
                      Pledge with no reward
                    </span>
                  </div>
                </label>
                <div className="no_reward_desc">
                  Choose to support us without a reward if you simply believe in
                  our project. As a <br /> backer, you will be signed up to
                  receive product updates via email.
                  {pledge === true ? ExpandModal() : ReverseModal()}
                  {pledge === true ? AddingPledge() : ReversePledge()}
                </div>
                {pledge === true ? (
                  <div className="pledge">
                    {" "}
                    <div className="enter_text">Enter your pledge</div>{" "}
                    <div className="dollar">$</div>{" "}
                    <div className="pledge_bubble">
                      {" "}
                      <input
                        type="number"
                        name=""
                        id=""
                        className="pledge_amount"
                        min="1"
                        onChange={(e) => setDonation(donation = parseInt(e.target.value))}
                      />{" "}
                    </div>
                    <button className="pledge_continue" onClick={() => CongratsModal()}>Continue</button>{" "}
                  </div>
                ) : (
                  console.log("")
                )}
              </div>
              <div className="bamboo_rewards" style={bamboo_styles}>
                <label htmlFor="choose_pledge2" className="radio2">
                  <input
                    type="radio"
                    name="no_reward"
                    className="radio__input2"
                    id="choose_pledge2"
                    onChange={() => ShowPledge((pledge = false))}
                    onClick={() => SetBlackPledge((blackPledge = false))}
                    onClick={() => SetbambooPledge((bambooPledge = true))}
                  />
                  <div className="radio__radio2"></div>
                  <div className="text_top">
                    <span
                      style={{
                        position: "relative",
                        left: 32,
                        top: 21,
                        fontWeight: 700,
                        fontSize: 19,
                      }}
                    >
                      Bamboo Stand
                    </span>
                  </div>
                </label>
                <div className="pricing">
                  <span
                    style={{
                      color: "hsl(176, 50%, 47%)",
                      fontWeight: 500,
                      fontSize: 16,
                      position: "relative",
                      left: 220,
                      bottom: 5,
                    }}
                  >
                    Pledge $25 or more
                  </span>
                </div>
                <span
                  style={{
                    position: "relative",
                    bottom: 31,
                    marginLeft: 555,
                    fontSize: 20,
                    fontWeight: 700,
                  }}
                >
                  101
                </span>
                <span
                  style={{
                    fontWeight: 300,
                    color: "hsl(0, 0%, 48%)",
                    fontSize: 15,
                    marginLeft: 8,
                    position: "relative",
                    bottom: 32,
                  }}
                >
                  left
                </span>
                <div className="bamboo_reward_desc">
                  You get an ergonomic stand made of natural bamboo. You've
                  helped us launch <br /> our promotional campaign, and you’ll
                  be added to a special Backer member list.
                </div>
                {bambooPledge === true ? (
                  <div className="bamboo_pledge">
                    {" "}
                    <div className="bamboo_enter_text">
                      Enter your pledge
                    </div>{" "}
                    <div className="bamboo_dollar">$</div>{" "}
                    <div className="bamboo_bubble">
                      {" "}
                      <input
                        type="number"
                        name=""
                        id=""
                        className="pledge_amount"
                        min="25"
                        placeholder="25"
                        onChange={(e) => setDonation(donation = parseInt(e.target.value))}
                      />{" "}
                    </div>{" "}
                  </div>
                ) : (
                  console.log("")
                )}
                {bambooPledge === true ? (
                  <button className="bamboo_continue" onClick={() => CongratsModal()}>Continue</button>
                ) : (
                  console.log("")
                )}
                {bambooPledge === true ? ExpandModal() : console.log("")}
                {bambooPledge === true ? Expandbamboo() : Reversebamboo()}
              </div>
              <div className="black_rewards" style={black_styles}>
                <label htmlFor="choose_pledge3" className="radio3">
                  <input
                    type="radio"
                    name="no_reward"
                    className="radio__input3"
                    id="choose_pledge3"
                    defaultChecked={true}
                    onClick={() => SetbambooPledge((bambooPledge = false))}
                    onChange={() => ShowPledge((pledge = false))}
                  />
                  {bambooPledge === false && pledge === false
                    ? (blackPledge = true)
                    : console.log("")}
                  <div className="radio__radio3"></div>
                  <div className="black_title">Black Edition Stand</div>
                </label>
                <div className="black_reward_price">Pledge $75 or more</div>
                <div className="black_products_left">64</div>
                <div className="black_left_text">left</div>
                <div className="black_details">
                  You get a Black Special Edition computer stand and a personal
                  thank you. <br /> You’ll be added to our Backer member list.
                  Shipping is included.
                </div>
                {blackPledge === true ? ExpandModal() : console.log("")}
                {blackPledge === true ? ExpandBlack() : ReverseBlack()}
                {blackPledge === true ? (
                  <div className="black_pledge">
                    {" "}
                    <div className="black_enter_text">
                      Enter your pledge
                    </div>{" "}
                    <div className="black_dollar">$</div>{" "}
                    <div className="bamboo_bubble">
                      {" "}
                      <input
                        defaultChecked
                        type="number"
                        name=""
                        id=""
                        className="pledge_amount"
                        min="75"
                        placeholder="75"
                        onChange={(e) => setDonation(donation = parseInt(e.target.value))}
                      />{" "}
                    </div>{" "}
                    <button className="black_continue" onClick={() => CongratsModal()}>Continue</button>{" "}
                  </div>
                ) : (
                  ReverseBlack()
                )}
              </div>
              <div className="mahogany_rewards">
                <div className="mahogany_reward_title">
                  Mahogany Special Edition
                </div>
                <div className="mahogany_reward_price">Pledge $200 or more</div>
                <div className="mahogany_products_left">0</div>
                <div className="mahogany_left_text">left</div>
                <div className="mahogany_details">
                  You get two Special Edition Mahogany stands, a Backer T-Shirt,
                  and a personal thank you. You’ll be added to our Backer member
                  list. Shipping is included.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      ) : null}
    </>
  );
}
